import { useMutation, useQueryClient } from '@tanstack/react-query';
import { take, uniqBy } from 'lodash';

import { LocationDetail } from './useGetLocations';
import { QueryKeys, StorageKeys } from 'utils/constants';

export const useUpdateLocationHistory = () => {
  const queryClient = useQueryClient();

  const updateLocationHistory = async (location: LocationDetail): Promise<LocationDetail> => {
    return new Promise((resolve, reject) => {
      try {
        // add the supplied Location to the search history
        const storedLocations: LocationDetail[] = JSON.parse(
          localStorage.getItem(StorageKeys.LocationHistory) || '[]',
        );
        const updatedPreferences = take(uniqBy([location, ...storedLocations], 'id'), 3);
        localStorage.setItem(StorageKeys.LocationHistory, JSON.stringify(updatedPreferences));
        return resolve(location);
      } catch (err) {
        return reject(err);
      }
    });
  };

  return useMutation({
    mutationFn: updateLocationHistory,
    onSuccess: (data, variables, context) => {
      queryClient.invalidateQueries([QueryKeys.LocationHistory]);
    },
  });
};
